export default {
  getPdf: (axios, digitalCertificateId, v = 'default') =>
    axios.get(
      `/api/digitalCertificates/${digitalCertificateId}/pdf?version=${v}`,
      { responseType: 'arraybuffer' },
    ),
}
